const styles = {
    gray: {
        color: "#6D7885"
    },
    black: {
        color: "#000000"
    }
}
export default styles;